<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="absolute top-0 left-0 right-0 bottom-0 w-full overflow-hidden flex items-center text-center justify-center z-50" v-show="loading"><spinner line-fg-color="#922C49" size="55" :line-size="5"></spinner></div>
        <form id="form" v-if="!loading" @submit.prevent="submitForm" class="flex flex-col h-full">
            <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
                <template slot="title">{{ type }} News Item</template>
            </page-header>

            <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>

            <div class="flex md:flex-row sm:flex-col flex-grow">
                <div class="md:w-3/4 sm:w-full p-4 sm:p-6 lg:px-6 bg-gray-200 border-r border-gray-400" v-show="activeTab === 'details'">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-text class="sm:col-span-12"
                                label="Title"
                                name="title"
                                placeholder="Title"
                                v-model="item.title"
                                :required="true"
                            />
                            <editor class="content-editor sm:col-span-12" label="" v-model="item.content" />
                        </div>
                    </ValidationObserver>
                    <div class="pt-2">
                        <label class="text-sm font-medium leading-5 text-gray-800 relative pb-1">Upload File</label>
                        <div class="relative flex flex-row items-center my-2">
                            <file-upload name="news" id="news" :folder="'news'" @uploaded="fileUploaded" @uploading="file_url=null" ></file-upload>
                            <div v-if="file_url">
                                <button type="button" class="bg-green-700 text-white text-xs mx-3 py-1 px-3" @click="copyFileUrl(true)">
                                    <font-awesome-icon class="mr-1 text-white" :icon="['fas', 'copy']" />Copy Link
                                </button>
                                <button type="button" class="bg-red-500 text-white text-xs py-1 px-3" @click="copyFileUrl(false)">
                                    <font-awesome-icon class="mr-1 text-white" :icon="['fas', 'times']" />Clear Link
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="md:w-1/4 sm:w-full px-4 sm:px-6 lg:px-6">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-toggle class="sm:col-span-6"
                                label="Members"
                                name="members"
                                v-model="item.members"
                                :required="false"
                                :readonly="$store.getters.permissions.indexOf('custom.publish-news') === -1"
                            />
                            <input-toggle class="sm:col-span-6"
                                label="Public"
                                name="public"
                                v-model="item.public"
                                :required="false"
                                :readonly="$store.getters.permissions.indexOf('custom.publish-news') === -1"
                            />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import axios from "axios";
import FormSetup from "../../mixins/Tabs";
import FormButtons from "../../mixins/FormButtons";

export default {
        name: "NewsItemForm",
        props: {
            id: {required: false},
            type: {required: true},
            return: {required: false, default: '/news-items'},
            page: {required: false, default: 'news-items'}
        },
        mixins: [
            FormSetup,
            FormButtons
        ],
        data: function () {
            return {
                resource: 'news-items',
                prefix: 'configuration',
                pageActions: {
                    buttons: [
                        {
                            label: 'Save',
                            icon: 'save',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'save',
                        },
                        {
                            label: 'View',
                            icon: 'eye',
                            iconClass: 'text-blue-600',
                            type: 'method',
                            method: 'view',
                            prefix: '/configuration',
                            display: this.type === "Edit"
                        },
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel',
                        }
                    ],
                    additional: []
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    },
                ],
                startTab: null,
                loading: true,
                submitted: false,
                errorMessage: '',
                showPostalAddress: 'hide',
                item: {},
                S3URL: process.env.VUE_APP_S3_URL,
                file_url: null,
            }
        },
        methods: {
            getData: function () {
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/news-items/' + this.id)
                    .then(response => {
                        this.item = response.data;
                        this.$Progress.finish();
                        this.loading = false;
                    })
                    .catch(() => {
                        this.$Progress.finish();
                        this.loading = false;
                    });
            },
            submitForm: function () {
                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    let _method;
                    let _url;
                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;

                    this.$store.commit('TOGGLE_BACKDROP', {open: true});
                    this.errorMessage = '';

                    if (this.id) {
                        _url = process.env.VUE_APP_API_URL + '/news-items/' + this.id;
                        _method = 'PUT';
                    } else if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/news-items/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/news-items';
                        _method = 'POST';
                    }

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {
                        if (response.data.success) {
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});

                            this.$router.push('/news-items');

                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });

                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            cancel: function () {
                this.$router.push(this.return);
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
            fileUploaded: function(payload){
                this.file_url = payload.data[0].path;
            },
            copyFileUrl: function(target){

                if(target){
                    navigator.clipboard.writeText(this.S3URL + '/' + this.file_url);
                } else{
                    navigator.clipboard.writeText('');
                    this.file_url = null;
                }

            }
        },
        beforeMount() {

        },
        mounted() {
            if (this.type === "New") {
                this.loading = false;
                this.item.active = true;
                this.$Progress.finish();
                // Se defaults here
            } else if (this.type === "Edit") {
                this.pageActions.additional.push({
                    label: 'Delete',
                    icon: 'trash-alt',
                    type: 'method',
                    method: 'deleteModal',
                    iconClass: 'text-red-500',
                    display: !!(this.$store.getters.permissions.indexOf('members.destroy') !== -1 || this.$store.getters.nimdarepus)
                });
                this.getData();
            }

            const params = new URLSearchParams(window.location.search)
            let windowLocationHash = window.location.hash.replace('#', '');

            if (windowLocationHash) {
                this.startTab = windowLocationHash;
            }
        },
        computed: {
            initialValue: function(){
                return {};
            }
        }
    }
</script>

<style>
.content-editor .ck.ck-editor__main > .ck-editor__editable {
    height: 50vh;
}
</style>
